function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiree8ef"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiree8ef"] = parcelRequire;
}
parcelRequire.register("lhc9U", function(module, exports) {

$parcel$export(module.exports, "register", () => $f7d49dfd4ff85d5a$export$6503ec6e8aabbaf, (v) => $f7d49dfd4ff85d5a$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $f7d49dfd4ff85d5a$export$f7ad0328861e2f03, (v) => $f7d49dfd4ff85d5a$export$f7ad0328861e2f03 = v);
var $f7d49dfd4ff85d5a$export$6503ec6e8aabbaf;
var $f7d49dfd4ff85d5a$export$f7ad0328861e2f03;
"use strict";
var $f7d49dfd4ff85d5a$var$mapping = {};
function $f7d49dfd4ff85d5a$var$register(pairs) {
    var keys = Object.keys(pairs);
    for(var i = 0; i < keys.length; i++)$f7d49dfd4ff85d5a$var$mapping[keys[i]] = pairs[keys[i]];
}
function $f7d49dfd4ff85d5a$var$resolve(id) {
    var resolved = $f7d49dfd4ff85d5a$var$mapping[id];
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return resolved;
}
$f7d49dfd4ff85d5a$export$6503ec6e8aabbaf = $f7d49dfd4ff85d5a$var$register;
$f7d49dfd4ff85d5a$export$f7ad0328861e2f03 = $f7d49dfd4ff85d5a$var$resolve;

});

parcelRequire.register("6206D", function(module, exports) {

$parcel$export(module.exports, "default", () => $464303085e459d2e$export$2e2bcd8739ae039);
/* src/components/icons/Camera.svelte generated by Svelte v3.58.0 */ 
var $fqHFZ = parcelRequire("fqHFZ");


var $5pIWq = parcelRequire("5pIWq");
function $464303085e459d2e$var$create_fragment(ctx) {
    let img;
    let img_class_value;
    let img_src_value;
    let mounted;
    let dispose;
    return {
        c () {
            img = (0, $fqHFZ.element)("img");
            (0, $fqHFZ.attr)(img, "class", img_class_value = "" + /*color*/ (ctx[0] + " " + /*size*/ ctx[1]));
            (0, $fqHFZ.attr)(img, "alt", /*alt*/ ctx[2]);
            if (!(0, $fqHFZ.src_url_equal)(img.src, img_src_value = /*iconUrl*/ ctx[3].pathname)) (0, $fqHFZ.attr)(img, "src", img_src_value);
        },
        m (target, anchor) {
            (0, $fqHFZ.insert)(target, img, anchor);
            if (!mounted) {
                dispose = [
                    (0, $fqHFZ.listen)(img, "click", /*click_handler*/ ctx[4]),
                    (0, $fqHFZ.listen)(img, "keydown", /*keydown_handler*/ ctx[5])
                ];
                mounted = true;
            }
        },
        p (ctx, [dirty]) {
            if (dirty & /*color, size*/ 3 && img_class_value !== (img_class_value = "" + /*color*/ (ctx[0] + " " + /*size*/ ctx[1]))) (0, $fqHFZ.attr)(img, "class", img_class_value);
            if (dirty & /*alt*/ 4) (0, $fqHFZ.attr)(img, "alt", /*alt*/ ctx[2]);
        },
        i: (0, $fqHFZ.noop),
        o: (0, $fqHFZ.noop),
        d (detaching) {
            if (detaching) (0, $fqHFZ.detach)(img);
            mounted = false;
            (0, $fqHFZ.run_all)(dispose);
        }
    };
}

function $464303085e459d2e$var$instance($$self, $$props, $$invalidate) {
    let { color: color = (0, $5pIWq.IconColor).Default  } = $$props;
    let { size: size = (0, $5pIWq.IconSize).Normal  } = $$props;
    let { alt: alt  } = $$props;
    // Replace the next lines to generate an icon.
    const iconUrl = new URL((parcelRequire("g3v0H")));
    function click_handler(event) {
        (0, $fqHFZ.bubble).call(this, $$self, event);
    }
    function keydown_handler(event) {
        (0, $fqHFZ.bubble).call(this, $$self, event);
    }
    $$self.$$set = ($$props)=>{
        if ("color" in $$props) $$invalidate(0, color = $$props.color);
        if ("size" in $$props) $$invalidate(1, size = $$props.size);
        if ("alt" in $$props) $$invalidate(2, alt = $$props.alt);
    };
    return [
        color,
        size,
        alt,
        iconUrl,
        click_handler,
        keydown_handler
    ];
}
class $464303085e459d2e$var$Camera extends (0, $fqHFZ.SvelteComponent) {
    constructor(options){
        super();
        (0, $fqHFZ.init)(this, options, $464303085e459d2e$var$instance, $464303085e459d2e$var$create_fragment, (0, $fqHFZ.safe_not_equal), {
            color: 0,
            size: 1,
            alt: 2
        });
    }
}
var $464303085e459d2e$export$2e2bcd8739ae039 = $464303085e459d2e$var$Camera;

});
parcelRequire.register("g3v0H", function(module, exports) {

module.exports = new URL("../" + (parcelRequire("lhc9U")).resolve("aG9uu"), import.meta.url).toString();

});


parcelRequire.register("k7Ova", function(module, exports) {

$parcel$export(module.exports, "default", () => $ea6ba2a856eae109$export$2e2bcd8739ae039);
/* src/components/icons/Search.svelte generated by Svelte v3.58.0 */ 
var $fqHFZ = parcelRequire("fqHFZ");


var $5pIWq = parcelRequire("5pIWq");
function $ea6ba2a856eae109$var$create_fragment(ctx) {
    let img;
    let img_class_value;
    let img_src_value;
    let mounted;
    let dispose;
    return {
        c () {
            img = (0, $fqHFZ.element)("img");
            (0, $fqHFZ.attr)(img, "class", img_class_value = "" + /*color*/ (ctx[0] + " " + /*size*/ ctx[1]));
            (0, $fqHFZ.attr)(img, "alt", /*alt*/ ctx[2]);
            if (!(0, $fqHFZ.src_url_equal)(img.src, img_src_value = /*iconUrl*/ ctx[3].pathname)) (0, $fqHFZ.attr)(img, "src", img_src_value);
        },
        m (target, anchor) {
            (0, $fqHFZ.insert)(target, img, anchor);
            if (!mounted) {
                dispose = [
                    (0, $fqHFZ.listen)(img, "click", /*click_handler*/ ctx[4]),
                    (0, $fqHFZ.listen)(img, "keydown", /*keydown_handler*/ ctx[5])
                ];
                mounted = true;
            }
        },
        p (ctx, [dirty]) {
            if (dirty & /*color, size*/ 3 && img_class_value !== (img_class_value = "" + /*color*/ (ctx[0] + " " + /*size*/ ctx[1]))) (0, $fqHFZ.attr)(img, "class", img_class_value);
            if (dirty & /*alt*/ 4) (0, $fqHFZ.attr)(img, "alt", /*alt*/ ctx[2]);
        },
        i: (0, $fqHFZ.noop),
        o: (0, $fqHFZ.noop),
        d (detaching) {
            if (detaching) (0, $fqHFZ.detach)(img);
            mounted = false;
            (0, $fqHFZ.run_all)(dispose);
        }
    };
}

function $ea6ba2a856eae109$var$instance($$self, $$props, $$invalidate) {
    let { color: color = (0, $5pIWq.IconColor).Default  } = $$props;
    let { size: size = (0, $5pIWq.IconSize).Normal  } = $$props;
    let { alt: alt  } = $$props;
    // Replace the next lines to generate an icon.
    const iconUrl = new URL((parcelRequire("e4lKW")));
    function click_handler(event) {
        (0, $fqHFZ.bubble).call(this, $$self, event);
    }
    function keydown_handler(event) {
        (0, $fqHFZ.bubble).call(this, $$self, event);
    }
    $$self.$$set = ($$props)=>{
        if ("color" in $$props) $$invalidate(0, color = $$props.color);
        if ("size" in $$props) $$invalidate(1, size = $$props.size);
        if ("alt" in $$props) $$invalidate(2, alt = $$props.alt);
    };
    return [
        color,
        size,
        alt,
        iconUrl,
        click_handler,
        keydown_handler
    ];
}
class $ea6ba2a856eae109$var$Search extends (0, $fqHFZ.SvelteComponent) {
    constructor(options){
        super();
        (0, $fqHFZ.init)(this, options, $ea6ba2a856eae109$var$instance, $ea6ba2a856eae109$var$create_fragment, (0, $fqHFZ.safe_not_equal), {
            color: 0,
            size: 1,
            alt: 2
        });
    }
}
var $ea6ba2a856eae109$export$2e2bcd8739ae039 = $ea6ba2a856eae109$var$Search;

});
parcelRequire.register("e4lKW", function(module, exports) {

module.exports = new URL("../" + (parcelRequire("lhc9U")).resolve("eVGQk"), import.meta.url).toString();

});


parcelRequire.register("fnooX", function(module, exports) {

$parcel$export(module.exports, "default", () => $b31beea4e93cdfaf$export$2e2bcd8739ae039);
/* src/components/ui/TextInput.svelte generated by Svelte v3.58.0 */ 
var $fqHFZ = parcelRequire("fqHFZ");
function $b31beea4e93cdfaf$var$create_else_block(ctx) {
    let input;
    let mounted;
    let dispose;
    return {
        c () {
            input = (0, $fqHFZ.element)("input");
            (0, $fqHFZ.attr)(input, "type", "text");
            (0, $fqHFZ.attr)(input, "placeholder", /*placeholder*/ ctx[1]);
            (0, $fqHFZ.attr)(input, "name", /*name*/ ctx[4]);
            input.disabled = /*disabled*/ ctx[2];
            input.required = /*required*/ ctx[3];
            (0, $fqHFZ.attr)(input, "class", "svelte-1o5sng2");
        },
        m (target, anchor) {
            (0, $fqHFZ.insert)(target, input, anchor);
            (0, $fqHFZ.set_input_value)(input, /*value*/ ctx[0]);
            if (!mounted) {
                dispose = (0, $fqHFZ.listen)(input, "input", /*input_input_handler_1*/ ctx[7]);
                mounted = true;
            }
        },
        p (ctx, dirty) {
            if (dirty & /*placeholder*/ 2) (0, $fqHFZ.attr)(input, "placeholder", /*placeholder*/ ctx[1]);
            if (dirty & /*name*/ 16) (0, $fqHFZ.attr)(input, "name", /*name*/ ctx[4]);
            if (dirty & /*disabled*/ 4) input.disabled = /*disabled*/ ctx[2];
            if (dirty & /*required*/ 8) input.required = /*required*/ ctx[3];
            if (dirty & /*value*/ 1 && input.value !== /*value*/ ctx[0]) (0, $fqHFZ.set_input_value)(input, /*value*/ ctx[0]);
        },
        d (detaching) {
            if (detaching) (0, $fqHFZ.detach)(input);
            mounted = false;
            dispose();
        }
    };
}
// (9:0) {#if label}
function $b31beea4e93cdfaf$var$create_if_block(ctx) {
    let label_1;
    let t0;
    let t1;
    let input;
    let mounted;
    let dispose;
    return {
        c () {
            label_1 = (0, $fqHFZ.element)("label");
            t0 = (0, $fqHFZ.text)(/*label*/ ctx[5]);
            t1 = (0, $fqHFZ.space)();
            input = (0, $fqHFZ.element)("input");
            (0, $fqHFZ.attr)(input, "type", "text");
            (0, $fqHFZ.attr)(input, "placeholder", /*placeholder*/ ctx[1]);
            (0, $fqHFZ.attr)(input, "name", /*name*/ ctx[4]);
            input.disabled = /*disabled*/ ctx[2];
            input.required = /*required*/ ctx[3];
            (0, $fqHFZ.attr)(input, "class", "svelte-1o5sng2");
        },
        m (target, anchor) {
            (0, $fqHFZ.insert)(target, label_1, anchor);
            (0, $fqHFZ.append)(label_1, t0);
            (0, $fqHFZ.append)(label_1, t1);
            (0, $fqHFZ.append)(label_1, input);
            (0, $fqHFZ.set_input_value)(input, /*value*/ ctx[0]);
            if (!mounted) {
                dispose = (0, $fqHFZ.listen)(input, "input", /*input_input_handler*/ ctx[6]);
                mounted = true;
            }
        },
        p (ctx, dirty) {
            if (dirty & /*label*/ 32) (0, $fqHFZ.set_data)(t0, /*label*/ ctx[5]);
            if (dirty & /*placeholder*/ 2) (0, $fqHFZ.attr)(input, "placeholder", /*placeholder*/ ctx[1]);
            if (dirty & /*name*/ 16) (0, $fqHFZ.attr)(input, "name", /*name*/ ctx[4]);
            if (dirty & /*disabled*/ 4) input.disabled = /*disabled*/ ctx[2];
            if (dirty & /*required*/ 8) input.required = /*required*/ ctx[3];
            if (dirty & /*value*/ 1 && input.value !== /*value*/ ctx[0]) (0, $fqHFZ.set_input_value)(input, /*value*/ ctx[0]);
        },
        d (detaching) {
            if (detaching) (0, $fqHFZ.detach)(label_1);
            mounted = false;
            dispose();
        }
    };
}
function $b31beea4e93cdfaf$var$create_fragment(ctx) {
    let if_block_anchor;
    function select_block_type(ctx, dirty) {
        if (/*label*/ ctx[5]) return $b31beea4e93cdfaf$var$create_if_block;
        return $b31beea4e93cdfaf$var$create_else_block;
    }
    let current_block_type = select_block_type(ctx, -1);
    let if_block = current_block_type(ctx);
    return {
        c () {
            if_block.c();
            if_block_anchor = (0, $fqHFZ.empty)();
        },
        m (target, anchor) {
            if_block.m(target, anchor);
            (0, $fqHFZ.insert)(target, if_block_anchor, anchor);
        },
        p (ctx, [dirty]) {
            if (current_block_type === (current_block_type = select_block_type(ctx, dirty)) && if_block) if_block.p(ctx, dirty);
            else {
                if_block.d(1);
                if_block = current_block_type(ctx);
                if (if_block) {
                    if_block.c();
                    if_block.m(if_block_anchor.parentNode, if_block_anchor);
                }
            }
        },
        i: (0, $fqHFZ.noop),
        o: (0, $fqHFZ.noop),
        d (detaching) {
            if_block.d(detaching);
            if (detaching) (0, $fqHFZ.detach)(if_block_anchor);
        }
    };
}
function $b31beea4e93cdfaf$var$instance($$self, $$props, $$invalidate) {
    let { placeholder: placeholder = ""  } = $$props;
    let { disabled: disabled = false  } = $$props;
    let { required: required = true  } = $$props;
    let { name: name  } = $$props;
    let { label: label  } = $$props;
    let { value: value = ""  } = $$props;
    function input_input_handler() {
        value = this.value;
        $$invalidate(0, value);
    }
    function input_input_handler_1() {
        value = this.value;
        $$invalidate(0, value);
    }
    $$self.$$set = ($$props)=>{
        if ("placeholder" in $$props) $$invalidate(1, placeholder = $$props.placeholder);
        if ("disabled" in $$props) $$invalidate(2, disabled = $$props.disabled);
        if ("required" in $$props) $$invalidate(3, required = $$props.required);
        if ("name" in $$props) $$invalidate(4, name = $$props.name);
        if ("label" in $$props) $$invalidate(5, label = $$props.label);
        if ("value" in $$props) $$invalidate(0, value = $$props.value);
    };
    return [
        value,
        placeholder,
        disabled,
        required,
        name,
        label,
        input_input_handler,
        input_input_handler_1
    ];
}
class $b31beea4e93cdfaf$var$TextInput extends (0, $fqHFZ.SvelteComponent) {
    constructor(options){
        super();
        (0, $fqHFZ.init)(this, options, $b31beea4e93cdfaf$var$instance, $b31beea4e93cdfaf$var$create_fragment, (0, $fqHFZ.safe_not_equal), {
            placeholder: 1,
            disabled: 2,
            required: 3,
            name: 4,
            label: 5,
            value: 0
        });
    }
}
var $b31beea4e93cdfaf$export$2e2bcd8739ae039 = $b31beea4e93cdfaf$var$TextInput;

});

parcelRequire.register("1I15o", function(module, exports) {

$parcel$export(module.exports, "default", () => $13eabe2de0da638c$export$2e2bcd8739ae039);
/* src/components/ui/QRScanner.svelte generated by Svelte v3.58.0 */ 
var $fqHFZ = parcelRequire("fqHFZ");

var $ehQTt = parcelRequire("ehQTt");
parcelRequire("bV2f2");
var $fqHFZ = parcelRequire("fqHFZ");

var $b2A4T = parcelRequire("b2A4T");

var $dxfvc = parcelRequire("dxfvc");

var $dCatT = parcelRequire("dCatT");

var $5pIWq = parcelRequire("5pIWq");

var $lGu5H = parcelRequire("lGu5H");
function $13eabe2de0da638c$var$create_catch_block(ctx) {
    return {
        c: (0, $fqHFZ.noop),
        m: (0, $fqHFZ.noop),
        p: (0, $fqHFZ.noop),
        i: (0, $fqHFZ.noop),
        o: (0, $fqHFZ.noop),
        d: (0, $fqHFZ.noop)
    };
}
// (65:4) {:then hasCamera}
function $13eabe2de0da638c$var$create_then_block(ctx) {
    let current_block_type_index;
    let if_block;
    let if_block_anchor;
    let current;
    const if_block_creators = [
        $13eabe2de0da638c$var$create_if_block,
        $13eabe2de0da638c$var$create_else_block_1
    ];
    const if_blocks = [];
    function select_block_type(ctx, dirty) {
        if (/*hasCamera*/ ctx[9]) return 0;
        return 1;
    }
    current_block_type_index = select_block_type(ctx, -1);
    if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
    return {
        c () {
            if_block.c();
            if_block_anchor = (0, $fqHFZ.empty)();
        },
        m (target, anchor) {
            if_blocks[current_block_type_index].m(target, anchor);
            (0, $fqHFZ.insert)(target, if_block_anchor, anchor);
            current = true;
        },
        p (ctx, dirty) {
            if_block.p(ctx, dirty);
        },
        i (local) {
            if (current) return;
            (0, $fqHFZ.transition_in)(if_block);
            current = true;
        },
        o (local) {
            (0, $fqHFZ.transition_out)(if_block);
            current = false;
        },
        d (detaching) {
            if_blocks[current_block_type_index].d(detaching);
            if (detaching) (0, $fqHFZ.detach)(if_block_anchor);
        }
    };
}
// (73:8) {:else}
function $13eabe2de0da638c$var$create_else_block_1(ctx) {
    let p;
    return {
        c () {
            p = (0, $fqHFZ.element)("p");
            p.textContent = "No cameras available.";
        },
        m (target, anchor) {
            (0, $fqHFZ.insert)(target, p, anchor);
        },
        p: (0, $fqHFZ.noop),
        i: (0, $fqHFZ.noop),
        o: (0, $fqHFZ.noop),
        d (detaching) {
            if (detaching) (0, $fqHFZ.detach)(p);
        }
    };
}
// (66:8) {#if hasCamera}
function $13eabe2de0da638c$var$create_if_block(ctx) {
    let current_block_type_index;
    let if_block;
    let if_block_anchor;
    let current;
    const if_block_creators = [
        $13eabe2de0da638c$var$create_if_block_1,
        $13eabe2de0da638c$var$create_else_block
    ];
    const if_blocks = [];
    function select_block_type_1(ctx, dirty) {
        if (/*camStart*/ ctx[0]) return 0;
        return 1;
    }
    current_block_type_index = select_block_type_1(ctx, -1);
    if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
    return {
        c () {
            if_block.c();
            if_block_anchor = (0, $fqHFZ.empty)();
        },
        m (target, anchor) {
            if_blocks[current_block_type_index].m(target, anchor);
            (0, $fqHFZ.insert)(target, if_block_anchor, anchor);
            current = true;
        },
        p (ctx, dirty) {
            let previous_block_index = current_block_type_index;
            current_block_type_index = select_block_type_1(ctx, dirty);
            if (current_block_type_index === previous_block_index) if_blocks[current_block_type_index].p(ctx, dirty);
            else {
                (0, $fqHFZ.group_outros)();
                (0, $fqHFZ.transition_out)(if_blocks[previous_block_index], 1, 1, ()=>{
                    if_blocks[previous_block_index] = null;
                });
                (0, $fqHFZ.check_outros)();
                if_block = if_blocks[current_block_type_index];
                if (!if_block) {
                    if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
                    if_block.c();
                } else if_block.p(ctx, dirty);
                (0, $fqHFZ.transition_in)(if_block, 1);
                if_block.m(if_block_anchor.parentNode, if_block_anchor);
            }
        },
        i (local) {
            if (current) return;
            (0, $fqHFZ.transition_in)(if_block);
            current = true;
        },
        o (local) {
            (0, $fqHFZ.transition_out)(if_block);
            current = false;
        },
        d (detaching) {
            if_blocks[current_block_type_index].d(detaching);
            if (detaching) (0, $fqHFZ.detach)(if_block_anchor);
        }
    };
}
// (70:16) {:else}
function $13eabe2de0da638c$var$create_else_block(ctx) {
    let button;
    let current;
    button = new (0, $dxfvc.default)({
        props: {
            $$slots: {
                default: [
                    $13eabe2de0da638c$var$create_default_slot_1
                ]
            },
            $$scope: {
                ctx: ctx
            }
        }
    });
    button.$on("click", /*startCamera*/ ctx[2]);
    return {
        c () {
            (0, $fqHFZ.create_component)(button.$$.fragment);
        },
        m (target, anchor) {
            (0, $fqHFZ.mount_component)(button, target, anchor);
            current = true;
        },
        p (ctx, dirty) {
            const button_changes = {};
            if (dirty & /*$$scope*/ 1024) button_changes.$$scope = {
                dirty: dirty,
                ctx: ctx
            };
            button.$set(button_changes);
        },
        i (local) {
            if (current) return;
            (0, $fqHFZ.transition_in)(button.$$.fragment, local);
            current = true;
        },
        o (local) {
            (0, $fqHFZ.transition_out)(button.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            (0, $fqHFZ.destroy_component)(button, detaching);
        }
    };
}
// (67:16) {#if camStart}
function $13eabe2de0da638c$var$create_if_block_1(ctx) {
    let p;
    let t1;
    let button;
    let current;
    button = new (0, $dxfvc.default)({
        props: {
            type: (0, $5pIWq.ButtonType).Secondary,
            $$slots: {
                default: [
                    $13eabe2de0da638c$var$create_default_slot
                ]
            },
            $$scope: {
                ctx: ctx
            }
        }
    });
    button.$on("click", /*stopCamera*/ ctx[3]);
    return {
        c () {
            p = (0, $fqHFZ.element)("p");
            p.textContent = "No valid QR code detected.";
            t1 = (0, $fqHFZ.space)();
            (0, $fqHFZ.create_component)(button.$$.fragment);
        },
        m (target, anchor) {
            (0, $fqHFZ.insert)(target, p, anchor);
            (0, $fqHFZ.insert)(target, t1, anchor);
            (0, $fqHFZ.mount_component)(button, target, anchor);
            current = true;
        },
        p (ctx, dirty) {
            const button_changes = {};
            if (dirty & /*$$scope*/ 1024) button_changes.$$scope = {
                dirty: dirty,
                ctx: ctx
            };
            button.$set(button_changes);
        },
        i (local) {
            if (current) return;
            (0, $fqHFZ.transition_in)(button.$$.fragment, local);
            current = true;
        },
        o (local) {
            (0, $fqHFZ.transition_out)(button.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            if (detaching) (0, $fqHFZ.detach)(p);
            if (detaching) (0, $fqHFZ.detach)(t1);
            (0, $fqHFZ.destroy_component)(button, detaching);
        }
    };
}
// (71:20) <Button on:click={startCamera}>
function $13eabe2de0da638c$var$create_default_slot_1(ctx) {
    let t;
    return {
        c () {
            t = (0, $fqHFZ.text)("Start Capture");
        },
        m (target, anchor) {
            (0, $fqHFZ.insert)(target, t, anchor);
        },
        d (detaching) {
            if (detaching) (0, $fqHFZ.detach)(t);
        }
    };
}
// (69:20) <Button type={ButtonType.Secondary} on:click={stopCamera}>
function $13eabe2de0da638c$var$create_default_slot(ctx) {
    let t;
    return {
        c () {
            t = (0, $fqHFZ.text)("End Capture");
        },
        m (target, anchor) {
            (0, $fqHFZ.insert)(target, t, anchor);
        },
        d (detaching) {
            if (detaching) (0, $fqHFZ.detach)(t);
        }
    };
}
// (63:34)          Loading cameras...     {:then hasCamera}
function $13eabe2de0da638c$var$create_pending_block(ctx) {
    let t;
    return {
        c () {
            t = (0, $fqHFZ.text)("Loading cameras...");
        },
        m (target, anchor) {
            (0, $fqHFZ.insert)(target, t, anchor);
        },
        p: (0, $fqHFZ.noop),
        i: (0, $fqHFZ.noop),
        o: (0, $fqHFZ.noop),
        d (detaching) {
            if (detaching) (0, $fqHFZ.detach)(t);
        }
    };
}
function $13eabe2de0da638c$var$create_fragment(ctx) {
    let div;
    let video;
    let t0;
    let promise;
    let t1;
    let p;
    let t3;
    let input;
    let current;
    let mounted;
    let dispose;
    let info = {
        ctx: ctx,
        current: null,
        token: null,
        hasCatch: false,
        pending: $13eabe2de0da638c$var$create_pending_block,
        then: $13eabe2de0da638c$var$create_then_block,
        catch: $13eabe2de0da638c$var$create_catch_block,
        value: 9,
        blocks: [
            ,
            ,
            , 
        ]
    };
    (0, $fqHFZ.handle_promise)(promise = (0, $ehQTt.default).hasCamera(), info);
    return {
        c () {
            div = (0, $fqHFZ.element)("div");
            video = (0, $fqHFZ.element)("video");
            video.innerHTML = `<track kind="captions"/>`;
            t0 = (0, $fqHFZ.space)();
            info.block.c();
            t1 = (0, $fqHFZ.space)();
            p = (0, $fqHFZ.element)("p");
            p.textContent = "Upload a file with the QR code:";
            t3 = (0, $fqHFZ.space)();
            input = (0, $fqHFZ.element)("input");
            (0, $fqHFZ.attr)(video, "class", "svelte-5j0nv");
            (0, $fqHFZ.attr)(input, "type", "file");
            (0, $fqHFZ.attr)(input, "accept", "image/*");
            (0, $fqHFZ.attr)(div, "class", "svelte-5j0nv");
        },
        m (target, anchor) {
            (0, $fqHFZ.insert)(target, div, anchor);
            (0, $fqHFZ.append)(div, video);
            /*video_binding*/ ctx[5](video);
            (0, $fqHFZ.append)(div, t0);
            info.block.m(div, info.anchor = null);
            info.mount = ()=>div;
            info.anchor = t1;
            (0, $fqHFZ.append)(div, t1);
            (0, $fqHFZ.append)(div, p);
            (0, $fqHFZ.append)(div, t3);
            (0, $fqHFZ.append)(div, input);
            current = true;
            if (!mounted) {
                dispose = (0, $fqHFZ.listen)(input, "change", /*handleFileInput*/ ctx[4]);
                mounted = true;
            }
        },
        p (new_ctx, [dirty]) {
            ctx = new_ctx;
            (0, $fqHFZ.update_await_block_branch)(info, ctx, dirty);
        },
        i (local) {
            if (current) return;
            (0, $fqHFZ.transition_in)(info.block);
            current = true;
        },
        o (local) {
            for(let i = 0; i < 3; i += 1){
                const block = info.blocks[i];
                (0, $fqHFZ.transition_out)(block);
            }
            current = false;
        },
        d (detaching) {
            if (detaching) (0, $fqHFZ.detach)(div);
            /*video_binding*/ ctx[5](null);
            info.block.d();
            info.token = null;
            info = null;
            mounted = false;
            dispose();
        }
    };
}
function $13eabe2de0da638c$var$instance($$self, $$props, $$invalidate) {
    const dispatch = (0, $fqHFZ.createEventDispatcher)();
    let camStart = false;
    let qrScanner = null;
    let videoElement = null;
    async function startCamera() {
        $$invalidate(0, camStart = true);
        await qrScanner?.start();
    }
    function stopCamera() {
        $$invalidate(0, camStart = false);
        return qrScanner?.stop();
    }
    async function handleFileInput() {
        (0, $dCatT.assert)(this.files !== null);
        const [first, ...rest] = this.files;
        (0, $dCatT.assert)(rest.length === 0);
        (0, $dCatT.assert)(typeof first !== "undefined");
        try {
            const { data: data  } = await (0, $ehQTt.default).scanImage(first, {
                returnDetailedScanResult: true
            });
            if (!data) return;
            dispatch((0, $5pIWq.Events).OnDocumentScan, (0, $b2A4T.DocumentSchema).shape.id.parse(data.trim()));
        } catch (err) {
            (0, $lGu5H.topToastMessage).enqueue({
                title: "Failed to Find QR code.",
                body: JSON.stringify(err)
            });
        }
        this.value = "";
    }
    function setup() {
        (0, $dCatT.assert)(videoElement instanceof HTMLVideoElement);
        return new (0, $ehQTt.default)(videoElement, (result)=>{
            if (!result.data) return;
            stopCamera();
            dispatch((0, $5pIWq.Events).OnDocumentScan, (0, $b2A4T.DocumentSchema).shape.id.parse(result.data.trim()));
        }, {
            highlightCodeOutline: true,
            highlightScanRegion: true,
            maxScansPerSecond: 1,
            returnDetailedScanResult: true,
            onDecodeError (err) {
                if (err === "No QR code found") return;
                (0, $lGu5H.topToastMessage).enqueue({
                    title: "Failed to Find QR code",
                    body: JSON.stringify(err)
                });
            }
        });
    }
    // Needs to be here so that the <video> tag is rendered before it is asserted
    (0, $fqHFZ.onMount)(()=>qrScanner = setup());
    // Otherwise, when the window is closed - browser still thinks you are recording.
    (0, $fqHFZ.onDestroy)(stopCamera);
    function video_binding($$value) {
        (0, $fqHFZ.binding_callbacks)[$$value ? "unshift" : "push"](()=>{
            videoElement = $$value;
            $$invalidate(1, videoElement);
        });
    }
    return [
        camStart,
        videoElement,
        startCamera,
        stopCamera,
        handleFileInput,
        video_binding
    ];
}
class $13eabe2de0da638c$var$QRScanner extends (0, $fqHFZ.SvelteComponent) {
    constructor(options){
        super();
        (0, $fqHFZ.init)(this, options, $13eabe2de0da638c$var$instance, $13eabe2de0da638c$var$create_fragment, (0, $fqHFZ.safe_not_equal), {});
    }
}
var $13eabe2de0da638c$export$2e2bcd8739ae039 = $13eabe2de0da638c$var$QRScanner;

});
parcelRequire.register("ehQTt", function(module, exports) {

$parcel$export(module.exports, "default", () => $a66baed0eb72a968$export$2e2bcd8739ae039);

class $a66baed0eb72a968$var$e {
    constructor(a, b, c, d, f){
        this._legacyCanvasSize = $a66baed0eb72a968$var$e.DEFAULT_CANVAS_SIZE;
        this._preferredCamera = "environment";
        this._maxScansPerSecond = 25;
        this._lastScanTimestamp = -1;
        this._destroyed = this._flashOn = this._paused = this._active = !1;
        this.$video = a;
        this.$canvas = document.createElement("canvas");
        c && "object" === typeof c ? this._onDecode = b : (c || d || f ? console.warn("You're using a deprecated version of the QrScanner constructor which will be removed in the future") : console.warn("Note that the type of the scan result passed to onDecode will change in the future. To already switch to the new api today, you can pass returnDetailedScanResult: true."), this._legacyOnDecode = b);
        b = "object" === typeof c ? c : {};
        this._onDecodeError = b.onDecodeError || ("function" === typeof c ? c : this._onDecodeError);
        this._calculateScanRegion = b.calculateScanRegion || ("function" === typeof d ? d : this._calculateScanRegion);
        this._preferredCamera = b.preferredCamera || f || this._preferredCamera;
        this._legacyCanvasSize = "number" === typeof c ? c : "number" === typeof d ? d : this._legacyCanvasSize;
        this._maxScansPerSecond = b.maxScansPerSecond || this._maxScansPerSecond;
        this._onPlay = this._onPlay.bind(this);
        this._onLoadedMetaData = this._onLoadedMetaData.bind(this);
        this._onVisibilityChange = this._onVisibilityChange.bind(this);
        this._updateOverlay = this._updateOverlay.bind(this);
        a.disablePictureInPicture = !0;
        a.playsInline = !0;
        a.muted = !0;
        let h = !1;
        a.hidden && (a.hidden = !1, h = !0);
        document.body.contains(a) || (document.body.appendChild(a), h = !0);
        c = a.parentElement;
        if (b.highlightScanRegion || b.highlightCodeOutline) {
            d = !!b.overlay;
            this.$overlay = b.overlay || document.createElement("div");
            f = this.$overlay.style;
            f.position = "absolute";
            f.display = "none";
            f.pointerEvents = "none";
            this.$overlay.classList.add("scan-region-highlight");
            if (!d && b.highlightScanRegion) {
                this.$overlay.innerHTML = '<svg class="scan-region-highlight-svg" viewBox="0 0 238 238" preserveAspectRatio="none" style="position:absolute;width:100%;height:100%;left:0;top:0;fill:none;stroke:#e9b213;stroke-width:4;stroke-linecap:round;stroke-linejoin:round"><path d="M31 2H10a8 8 0 0 0-8 8v21M207 2h21a8 8 0 0 1 8 8v21m0 176v21a8 8 0 0 1-8 8h-21m-176 0H10a8 8 0 0 1-8-8v-21"/></svg>';
                try {
                    this.$overlay.firstElementChild.animate({
                        transform: [
                            "scale(.98)",
                            "scale(1.01)"
                        ]
                    }, {
                        duration: 400,
                        iterations: Infinity,
                        direction: "alternate",
                        easing: "ease-in-out"
                    });
                } catch (m) {}
                c.insertBefore(this.$overlay, this.$video.nextSibling);
            }
            b.highlightCodeOutline && (this.$overlay.insertAdjacentHTML("beforeend", '<svg class="code-outline-highlight" preserveAspectRatio="none" style="display:none;width:100%;height:100%;fill:none;stroke:#e9b213;stroke-width:5;stroke-dasharray:25;stroke-linecap:round;stroke-linejoin:round"><polygon/></svg>'), this.$codeOutlineHighlight = this.$overlay.lastElementChild);
        }
        this._scanRegion = this._calculateScanRegion(a);
        requestAnimationFrame(()=>{
            let m = window.getComputedStyle(a);
            "none" === m.display && (a.style.setProperty("display", "block", "important"), h = !0);
            "visible" !== m.visibility && (a.style.setProperty("visibility", "visible", "important"), h = !0);
            h && (console.warn("QrScanner has overwritten the video hiding style to avoid Safari stopping the playback."), a.style.opacity = "0", a.style.width = "0", a.style.height = "0", this.$overlay && this.$overlay.parentElement && this.$overlay.parentElement.removeChild(this.$overlay), delete this.$overlay, delete this.$codeOutlineHighlight);
            this.$overlay && this._updateOverlay();
        });
        a.addEventListener("play", this._onPlay);
        a.addEventListener("loadedmetadata", this._onLoadedMetaData);
        document.addEventListener("visibilitychange", this._onVisibilityChange);
        window.addEventListener("resize", this._updateOverlay);
        this._qrEnginePromise = $a66baed0eb72a968$var$e.createQrEngine();
    }
    static set WORKER_PATH(a) {
        console.warn("Setting QrScanner.WORKER_PATH is not required and not supported anymore. Have a look at the README for new setup instructions.");
    }
    static async hasCamera() {
        try {
            return !!(await $a66baed0eb72a968$var$e.listCameras(!1)).length;
        } catch (a) {
            return !1;
        }
    }
    static async listCameras(a = !1) {
        if (!navigator.mediaDevices) return [];
        let b = async ()=>(await navigator.mediaDevices.enumerateDevices()).filter((d)=>"videoinput" === d.kind), c;
        try {
            a && (await b()).every((d)=>!d.label) && (c = await navigator.mediaDevices.getUserMedia({
                audio: !1,
                video: !0
            }));
        } catch (d) {}
        try {
            return (await b()).map((d, f)=>({
                    id: d.deviceId,
                    label: d.label || (0 === f ? "Default Camera" : `Camera ${f + 1}`)
                }));
        } finally{
            c && (console.warn("Call listCameras after successfully starting a QR scanner to avoid creating a temporary video stream"), $a66baed0eb72a968$var$e._stopVideoStream(c));
        }
    }
    async hasFlash() {
        let a;
        try {
            if (this.$video.srcObject) {
                if (!(this.$video.srcObject instanceof MediaStream)) return !1;
                a = this.$video.srcObject;
            } else a = (await this._getCameraStream()).stream;
            return "torch" in a.getVideoTracks()[0].getSettings();
        } catch (b) {
            return !1;
        } finally{
            a && a !== this.$video.srcObject && (console.warn("Call hasFlash after successfully starting the scanner to avoid creating a temporary video stream"), $a66baed0eb72a968$var$e._stopVideoStream(a));
        }
    }
    isFlashOn() {
        return this._flashOn;
    }
    async toggleFlash() {
        this._flashOn ? await this.turnFlashOff() : await this.turnFlashOn();
    }
    async turnFlashOn() {
        if (!this._flashOn && !this._destroyed && (this._flashOn = !0, this._active && !this._paused)) try {
            if (!await this.hasFlash()) throw "No flash available";
            await this.$video.srcObject.getVideoTracks()[0].applyConstraints({
                advanced: [
                    {
                        torch: !0
                    }
                ]
            });
        } catch (a) {
            throw this._flashOn = !1, a;
        }
    }
    async turnFlashOff() {
        this._flashOn && (this._flashOn = !1, await this._restartVideoStream());
    }
    destroy() {
        this.$video.removeEventListener("loadedmetadata", this._onLoadedMetaData);
        this.$video.removeEventListener("play", this._onPlay);
        document.removeEventListener("visibilitychange", this._onVisibilityChange);
        window.removeEventListener("resize", this._updateOverlay);
        this._destroyed = !0;
        this._flashOn = !1;
        this.stop();
        $a66baed0eb72a968$var$e._postWorkerMessage(this._qrEnginePromise, "close");
    }
    async start() {
        if (this._destroyed) throw Error("The QR scanner can not be started as it had been destroyed.");
        if (!this._active || this._paused) {
            if ("https:" !== window.location.protocol && console.warn("The camera stream is only accessible if the page is transferred via https."), this._active = !0, !document.hidden) {
                if (this._paused = !1, this.$video.srcObject) await this.$video.play();
                else try {
                    let { stream: a , facingMode: b  } = await this._getCameraStream();
                    !this._active || this._paused ? $a66baed0eb72a968$var$e._stopVideoStream(a) : (this._setVideoMirror(b), this.$video.srcObject = a, await this.$video.play(), this._flashOn && (this._flashOn = !1, this.turnFlashOn().catch(()=>{})));
                } catch (a) {
                    if (!this._paused) throw this._active = !1, a;
                }
            }
        }
    }
    stop() {
        this.pause();
        this._active = !1;
    }
    async pause(a = !1) {
        this._paused = !0;
        if (!this._active) return !0;
        this.$video.pause();
        this.$overlay && (this.$overlay.style.display = "none");
        let b = ()=>{
            this.$video.srcObject instanceof MediaStream && ($a66baed0eb72a968$var$e._stopVideoStream(this.$video.srcObject), this.$video.srcObject = null);
        };
        if (a) return b(), !0;
        await new Promise((c)=>setTimeout(c, 300));
        if (!this._paused) return !1;
        b();
        return !0;
    }
    async setCamera(a) {
        a !== this._preferredCamera && (this._preferredCamera = a, await this._restartVideoStream());
    }
    static async scanImage(a, b, c, d, f = !1, h = !1) {
        let m, n = !1;
        b && ("scanRegion" in b || "qrEngine" in b || "canvas" in b || "disallowCanvasResizing" in b || "alsoTryWithoutScanRegion" in b || "returnDetailedScanResult" in b) ? (m = b.scanRegion, c = b.qrEngine, d = b.canvas, f = b.disallowCanvasResizing || !1, h = b.alsoTryWithoutScanRegion || !1, n = !0) : b || c || d || f || h ? console.warn("You're using a deprecated api for scanImage which will be removed in the future.") : console.warn("Note that the return type of scanImage will change in the future. To already switch to the new api today, you can pass returnDetailedScanResult: true.");
        b = !!c;
        try {
            let p, k;
            [c, p] = await Promise.all([
                c || $a66baed0eb72a968$var$e.createQrEngine(),
                $a66baed0eb72a968$var$e._loadImage(a)
            ]);
            [d, k] = $a66baed0eb72a968$var$e._drawToCanvas(p, m, d, f);
            let q;
            if (c instanceof Worker) {
                let g = c;
                b || $a66baed0eb72a968$var$e._postWorkerMessageSync(g, "inversionMode", "both");
                q = await new Promise((l, v)=>{
                    let w, u, r, y = -1;
                    u = (t)=>{
                        t.data.id === y && (g.removeEventListener("message", u), g.removeEventListener("error", r), clearTimeout(w), null !== t.data.data ? l({
                            data: t.data.data,
                            cornerPoints: $a66baed0eb72a968$var$e._convertPoints(t.data.cornerPoints, m)
                        }) : v($a66baed0eb72a968$var$e.NO_QR_CODE_FOUND));
                    };
                    r = (t)=>{
                        g.removeEventListener("message", u);
                        g.removeEventListener("error", r);
                        clearTimeout(w);
                        v("Scanner error: " + (t ? t.message || t : "Unknown Error"));
                    };
                    g.addEventListener("message", u);
                    g.addEventListener("error", r);
                    w = setTimeout(()=>r("timeout"), 1E4);
                    let x = k.getImageData(0, 0, d.width, d.height);
                    y = $a66baed0eb72a968$var$e._postWorkerMessageSync(g, "decode", x, [
                        x.data.buffer
                    ]);
                });
            } else q = await Promise.race([
                new Promise((g, l)=>window.setTimeout(()=>l("Scanner error: timeout"), 1E4)),
                (async ()=>{
                    try {
                        var [g] = await c.detect(d);
                        if (!g) throw $a66baed0eb72a968$var$e.NO_QR_CODE_FOUND;
                        return {
                            data: g.rawValue,
                            cornerPoints: $a66baed0eb72a968$var$e._convertPoints(g.cornerPoints, m)
                        };
                    } catch (l) {
                        g = l.message || l;
                        if (/not implemented|service unavailable/.test(g)) return $a66baed0eb72a968$var$e._disableBarcodeDetector = !0, $a66baed0eb72a968$var$e.scanImage(a, {
                            scanRegion: m,
                            canvas: d,
                            disallowCanvasResizing: f,
                            alsoTryWithoutScanRegion: h
                        });
                        throw `Scanner error: ${g}`;
                    }
                })()
            ]);
            return n ? q : q.data;
        } catch (p) {
            if (!m || !h) throw p;
            let k = await $a66baed0eb72a968$var$e.scanImage(a, {
                qrEngine: c,
                canvas: d,
                disallowCanvasResizing: f
            });
            return n ? k : k.data;
        } finally{
            b || $a66baed0eb72a968$var$e._postWorkerMessage(c, "close");
        }
    }
    setGrayscaleWeights(a, b, c, d = !0) {
        $a66baed0eb72a968$var$e._postWorkerMessage(this._qrEnginePromise, "grayscaleWeights", {
            red: a,
            green: b,
            blue: c,
            useIntegerApproximation: d
        });
    }
    setInversionMode(a) {
        $a66baed0eb72a968$var$e._postWorkerMessage(this._qrEnginePromise, "inversionMode", a);
    }
    static async createQrEngine(a) {
        a && console.warn("Specifying a worker path is not required and not supported anymore.");
        a = ()=>(parcelRequire("h8i5D")).then((c)=>c.createWorker());
        if (!(!$a66baed0eb72a968$var$e._disableBarcodeDetector && "BarcodeDetector" in window && BarcodeDetector.getSupportedFormats && (await BarcodeDetector.getSupportedFormats()).includes("qr_code"))) return a();
        let b = navigator.userAgentData;
        return b && b.brands.some(({ brand: c  })=>/Chromium/i.test(c)) && /mac ?OS/i.test(b.platform) && await b.getHighEntropyValues([
            "architecture",
            "platformVersion"
        ]).then(({ architecture: c , platformVersion: d  })=>/arm/i.test(c || "arm") && 13 <= parseInt(d || "13")).catch(()=>!0) ? a() : new BarcodeDetector({
            formats: [
                "qr_code"
            ]
        });
    }
    _onPlay() {
        this._scanRegion = this._calculateScanRegion(this.$video);
        this._updateOverlay();
        this.$overlay && (this.$overlay.style.display = "");
        this._scanFrame();
    }
    _onLoadedMetaData() {
        this._scanRegion = this._calculateScanRegion(this.$video);
        this._updateOverlay();
    }
    _onVisibilityChange() {
        document.hidden ? this.pause() : this._active && this.start();
    }
    _calculateScanRegion(a) {
        let b = Math.round(2 / 3 * Math.min(a.videoWidth, a.videoHeight));
        return {
            x: Math.round((a.videoWidth - b) / 2),
            y: Math.round((a.videoHeight - b) / 2),
            width: b,
            height: b,
            downScaledWidth: this._legacyCanvasSize,
            downScaledHeight: this._legacyCanvasSize
        };
    }
    _updateOverlay() {
        requestAnimationFrame(()=>{
            if (this.$overlay) {
                var a = this.$video, b = a.videoWidth, c = a.videoHeight, d = a.offsetWidth, f = a.offsetHeight, h = a.offsetLeft, m = a.offsetTop, n = window.getComputedStyle(a), p = n.objectFit, k = b / c, q = d / f;
                switch(p){
                    case "none":
                        var g = b;
                        var l = c;
                        break;
                    case "fill":
                        g = d;
                        l = f;
                        break;
                    default:
                        ("cover" === p ? k > q : k < q) ? (l = f, g = l * k) : (g = d, l = g / k), "scale-down" === p && (g = Math.min(g, b), l = Math.min(l, c));
                }
                var [v, w] = n.objectPosition.split(" ").map((r, y)=>{
                    const x = parseFloat(r);
                    return r.endsWith("%") ? (y ? f - l : d - g) * x / 100 : x;
                });
                n = this._scanRegion.width || b;
                q = this._scanRegion.height || c;
                p = this._scanRegion.x || 0;
                var u = this._scanRegion.y || 0;
                k = this.$overlay.style;
                k.width = `${n / b * g}px`;
                k.height = `${q / c * l}px`;
                k.top = `${m + w + u / c * l}px`;
                c = /scaleX\(-1\)/.test(a.style.transform);
                k.left = `${h + (c ? d - v - g : v) + (c ? b - p - n : p) / b * g}px`;
                k.transform = a.style.transform;
            }
        });
    }
    static _convertPoints(a, b) {
        if (!b) return a;
        let c = b.x || 0, d = b.y || 0, f = b.width && b.downScaledWidth ? b.width / b.downScaledWidth : 1;
        b = b.height && b.downScaledHeight ? b.height / b.downScaledHeight : 1;
        for (let h of a)h.x = h.x * f + c, h.y = h.y * b + d;
        return a;
    }
    _scanFrame() {
        !this._active || this.$video.paused || this.$video.ended || ("requestVideoFrameCallback" in this.$video ? this.$video.requestVideoFrameCallback.bind(this.$video) : requestAnimationFrame)(async ()=>{
            if (!(1 >= this.$video.readyState)) {
                var a = Date.now() - this._lastScanTimestamp, b = 1E3 / this._maxScansPerSecond;
                a < b && await new Promise((d)=>setTimeout(d, b - a));
                this._lastScanTimestamp = Date.now();
                try {
                    var c = await $a66baed0eb72a968$var$e.scanImage(this.$video, {
                        scanRegion: this._scanRegion,
                        qrEngine: this._qrEnginePromise,
                        canvas: this.$canvas
                    });
                } catch (d) {
                    if (!this._active) return;
                    this._onDecodeError(d);
                }
                !$a66baed0eb72a968$var$e._disableBarcodeDetector || await this._qrEnginePromise instanceof Worker || (this._qrEnginePromise = $a66baed0eb72a968$var$e.createQrEngine());
                c ? (this._onDecode ? this._onDecode(c) : this._legacyOnDecode && this._legacyOnDecode(c.data), this.$codeOutlineHighlight && (clearTimeout(this._codeOutlineHighlightRemovalTimeout), this._codeOutlineHighlightRemovalTimeout = void 0, this.$codeOutlineHighlight.setAttribute("viewBox", `${this._scanRegion.x || 0} ` + `${this._scanRegion.y || 0} ` + `${this._scanRegion.width || this.$video.videoWidth} ` + `${this._scanRegion.height || this.$video.videoHeight}`), this.$codeOutlineHighlight.firstElementChild.setAttribute("points", c.cornerPoints.map(({ x: d , y: f  })=>`${d},${f}`).join(" ")), this.$codeOutlineHighlight.style.display = "")) : this.$codeOutlineHighlight && !this._codeOutlineHighlightRemovalTimeout && (this._codeOutlineHighlightRemovalTimeout = setTimeout(()=>this.$codeOutlineHighlight.style.display = "none", 100));
            }
            this._scanFrame();
        });
    }
    _onDecodeError(a) {
        a !== $a66baed0eb72a968$var$e.NO_QR_CODE_FOUND && console.log(a);
    }
    async _getCameraStream() {
        if (!navigator.mediaDevices) throw "Camera not found.";
        let a = /^(environment|user)$/.test(this._preferredCamera) ? "facingMode" : "deviceId", b = [
            {
                width: {
                    min: 1024
                }
            },
            {
                width: {
                    min: 768
                }
            },
            {}
        ], c = b.map((d)=>Object.assign({}, d, {
                [a]: {
                    exact: this._preferredCamera
                }
            }));
        for (let d of [
            ...c,
            ...b
        ])try {
            let f = await navigator.mediaDevices.getUserMedia({
                video: d,
                audio: !1
            }), h = this._getFacingMode(f) || (d.facingMode ? this._preferredCamera : "environment" === this._preferredCamera ? "user" : "environment");
            return {
                stream: f,
                facingMode: h
            };
        } catch (f) {}
        throw "Camera not found.";
    }
    async _restartVideoStream() {
        let a = this._paused;
        await this.pause(!0) && !a && this._active && await this.start();
    }
    static _stopVideoStream(a) {
        for (let b of a.getTracks())b.stop(), a.removeTrack(b);
    }
    _setVideoMirror(a) {
        this.$video.style.transform = "scaleX(" + ("user" === a ? -1 : 1) + ")";
    }
    _getFacingMode(a) {
        return (a = a.getVideoTracks()[0]) ? /rear|back|environment/i.test(a.label) ? "environment" : /front|user|face/i.test(a.label) ? "user" : null : null;
    }
    static _drawToCanvas(a, b, c, d = !1) {
        c = c || document.createElement("canvas");
        let f = b && b.x ? b.x : 0, h = b && b.y ? b.y : 0, m = b && b.width ? b.width : a.videoWidth || a.width, n = b && b.height ? b.height : a.videoHeight || a.height;
        d || (d = b && b.downScaledWidth ? b.downScaledWidth : m, b = b && b.downScaledHeight ? b.downScaledHeight : n, c.width !== d && (c.width = d), c.height !== b && (c.height = b));
        b = c.getContext("2d", {
            alpha: !1
        });
        b.imageSmoothingEnabled = !1;
        b.drawImage(a, f, h, m, n, 0, 0, c.width, c.height);
        return [
            c,
            b
        ];
    }
    static async _loadImage(a) {
        if (a instanceof Image) return await $a66baed0eb72a968$var$e._awaitImageLoad(a), a;
        if (a instanceof HTMLVideoElement || a instanceof HTMLCanvasElement || a instanceof SVGImageElement || "OffscreenCanvas" in window && a instanceof OffscreenCanvas || "ImageBitmap" in window && a instanceof ImageBitmap) return a;
        if (a instanceof File || a instanceof Blob || a instanceof URL || "string" === typeof a) {
            let b = new Image;
            b.src = a instanceof File || a instanceof Blob ? URL.createObjectURL(a) : a.toString();
            try {
                return await $a66baed0eb72a968$var$e._awaitImageLoad(b), b;
            } finally{
                (a instanceof File || a instanceof Blob) && URL.revokeObjectURL(b.src);
            }
        } else throw "Unsupported image type.";
    }
    static async _awaitImageLoad(a) {
        a.complete && 0 !== a.naturalWidth || await new Promise((b, c)=>{
            let d = (f)=>{
                a.removeEventListener("load", d);
                a.removeEventListener("error", d);
                f instanceof ErrorEvent ? c("Image load error") : b();
            };
            a.addEventListener("load", d);
            a.addEventListener("error", d);
        });
    }
    static async _postWorkerMessage(a, b, c, d) {
        return $a66baed0eb72a968$var$e._postWorkerMessageSync(await a, b, c, d);
    }
    static _postWorkerMessageSync(a, b, c, d) {
        if (!(a instanceof Worker)) return -1;
        let f = $a66baed0eb72a968$var$e._workerMessageId++;
        a.postMessage({
            id: f,
            type: b,
            data: c
        }, d);
        return f;
    }
}
$a66baed0eb72a968$var$e.DEFAULT_CANVAS_SIZE = 400;
$a66baed0eb72a968$var$e.NO_QR_CODE_FOUND = "No QR code found";
$a66baed0eb72a968$var$e._disableBarcodeDetector = !1;
$a66baed0eb72a968$var$e._workerMessageId = 0;
var $a66baed0eb72a968$export$2e2bcd8739ae039 = $a66baed0eb72a968$var$e;

});
parcelRequire.register("h8i5D", function(module, exports) {

module.exports = import("./../" + (parcelRequire("lhc9U")).resolve("54W8y")).then(()=>parcelRequire("21EI0"));

});


parcelRequire.register("bV2f2", function(module, exports) {

$parcel$export(module.exports, "afterUpdate", () => (parcelRequire("fqHFZ")).afterUpdate);
$parcel$export(module.exports, "createEventDispatcher", () => (parcelRequire("fqHFZ")).createEventDispatcher);
$parcel$export(module.exports, "onDestroy", () => (parcelRequire("fqHFZ")).onDestroy);
$parcel$export(module.exports, "onMount", () => (parcelRequire("fqHFZ")).onMount);
$parcel$export(module.exports, "tick", () => (parcelRequire("fqHFZ")).tick);

var $fqHFZ = parcelRequire("fqHFZ");

});


parcelRequire.register("89uIq", function(module, exports) {

$parcel$export(module.exports, "default", () => $5ef6fd700d478ee7$export$2e2bcd8739ae039);
/* src/components/icons/Techstack.svelte generated by Svelte v3.58.0 */ 
var $fqHFZ = parcelRequire("fqHFZ");
function $5ef6fd700d478ee7$var$create_fragment(ctx) {
    let img;
    let img_src_value;
    let mounted;
    let dispose;
    return {
        c () {
            img = (0, $fqHFZ.element)("img");
            (0, $fqHFZ.attr)(img, "alt", /*alt*/ ctx[0]);
            if (!(0, $fqHFZ.src_url_equal)(img.src, img_src_value = /*techstackIcon*/ ctx[1].pathname)) (0, $fqHFZ.attr)(img, "src", img_src_value);
        },
        m (target, anchor) {
            (0, $fqHFZ.insert)(target, img, anchor);
            if (!mounted) {
                dispose = [
                    (0, $fqHFZ.listen)(img, "click", /*click_handler*/ ctx[2]),
                    (0, $fqHFZ.listen)(img, "keydown", /*keydown_handler*/ ctx[3])
                ];
                mounted = true;
            }
        },
        p (ctx, [dirty]) {
            if (dirty & /*alt*/ 1) (0, $fqHFZ.attr)(img, "alt", /*alt*/ ctx[0]);
        },
        i: (0, $fqHFZ.noop),
        o: (0, $fqHFZ.noop),
        d (detaching) {
            if (detaching) (0, $fqHFZ.detach)(img);
            mounted = false;
            (0, $fqHFZ.run_all)(dispose);
        }
    };
}

function $5ef6fd700d478ee7$var$instance($$self, $$props, $$invalidate) {
    let { alt: alt  } = $$props;
    // Replace the next lines to generate an icon.
    const techstackIcon = new URL((parcelRequire("aMUYv")));
    function click_handler(event) {
        (0, $fqHFZ.bubble).call(this, $$self, event);
    }
    function keydown_handler(event) {
        (0, $fqHFZ.bubble).call(this, $$self, event);
    }
    $$self.$$set = ($$props)=>{
        if ("alt" in $$props) $$invalidate(0, alt = $$props.alt);
    };
    return [
        alt,
        techstackIcon,
        click_handler,
        keydown_handler
    ];
}
class $5ef6fd700d478ee7$var$Techstack extends (0, $fqHFZ.SvelteComponent) {
    constructor(options){
        super();
        (0, $fqHFZ.init)(this, options, $5ef6fd700d478ee7$var$instance, $5ef6fd700d478ee7$var$create_fragment, (0, $fqHFZ.safe_not_equal), {
            alt: 0
        });
    }
}
var $5ef6fd700d478ee7$export$2e2bcd8739ae039 = $5ef6fd700d478ee7$var$Techstack;

});
parcelRequire.register("aMUYv", function(module, exports) {

module.exports = new URL("../" + (parcelRequire("lhc9U")).resolve("5Y6hG"), import.meta.url).toString();

});


parcelRequire.register("cNg0i", function(module, exports) {

$parcel$export(module.exports, "goToTrackingPage", () => $8c83dc121b3c72bc$export$29e5a2111cc63d6c);
$parcel$export(module.exports, "findDeferredSnapshot", () => $8c83dc121b3c72bc$export$b5bdaf421bcb868b);
function $8c83dc121b3c72bc$export$29e5a2111cc63d6c(id) {
    window.location.href = `/track?id=${id}`;
}
function $8c83dc121b3c72bc$export$b5bdaf421bcb868b(store, doc) {
    return store.findIndex((def)=>def.doc === doc) >= 0;
}

});

var $20a62b183c6c2b97$exports = {};

(parcelRequire("lhc9U")).register(JSON.parse('{"a7kaV":"index.e7fc8fb5.js","aG9uu":"camera.553fef8f.svg","eVGQk":"search.bb196d04.svg","54W8y":"qr-scanner-worker.min.d184d9ac.js","5Y6hG":"techstack.abb96200.svg","hoSvc":"index.e012de4f.css"}'));


//# sourceMappingURL=index.e7fc8fb5.js.map
